module.exports = __webpack_public_path__ + "img/JgIndex5.cc45a2ef.png";